import React, { HtmlHTMLAttributes } from "react";
import styled from "styled-components";

type ClickableProps = HtmlHTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  dataTestId?: string;
  disabled?: boolean;
  hover?: boolean;
  ref?: React.Ref<HTMLDivElement>;
};

// @ts-ignore
const ClickableComponent = styled.div.attrs(
  // @ts-ignore
  ({ dataTestId }: ClickableProps) => ({
    "data-testid": dataTestId,
  }),
)<ClickableProps>`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  ${({ hover, theme }) =>
    hover &&
    `&:hover { background-color: ${theme["lightMain"]};
      color: ${theme["white"]}
    }`};
`;

export const Clickable: React.FC<ClickableProps> = ({ children, ...props }) => {
  return (
    <ClickableComponent
      {...props}
      onClick={props.disabled ? undefined : props.onClick}
    >
      {children}
    </ClickableComponent>
  );
};
